import React, { useState } from 'react';
import { Swiper, SwiperSlide } from 'swiper/react';
import SwiperCore, { Navigation } from 'swiper';
import "swiper/css";
// import './styles.css';
// import 'swiper/swiper-bundle.css';

import img4 from "../../images/testiimg1.png";
import img5 from "../../images/testiimg2.png";
import img6 from "../../images/testiimg3.png";
const data = [
  {
    id: 1,
    userImage: <img  className="QL---Img---Testimonial" src={img4} alt="img" />,
    userName: "Mehwish",
    message:
      " Lorem ipsum dolor sit amet, consetetur sadipscing elitr, sed diam nonumy eirmod tempor invidunt ut labore et dolore magna aliquyam erat, sed diam voluptua. At vero eos et accusam et justo",
  },
  {
    id: 2,
    userImage: <img className="QL---Img---Testimonial" src={img5} alt="img" />,
    userName: "Arham",
    message:
      " Lorem ipsum dolor sit amet, consetetur sadipscing elitr, sed diam nonumy eirmod tempor invidunt ut labore  aliquyamLorem ipsum dolor sit amet, consetetur sadipscing elitr, sed diam ",
  },
  {
    id: 3,
    userImage: <img className="QL---Img---Testimonial" src={img6} alt="img" />,
    userName: "Fatima",
    message:
      " Lorem ipsum dolor sit amet, consetetur sadipscing elitr, sed diam nonumy eirmod tempor invidunt ut labore  aliquyamLorem ipsum dolor sit amet, consetetur sadipscing elitr, sed diam ",
  },
  {
    id: 4,
    userImage: <img className="QL---Img---Testimonial" src={img4} alt="img" />,
    userName: "Sahar",
    message:
      " Lorem ipsum dolor sit amet, consetetur sadipscing elitr, sed diam nonumy eirmod tempor invidunt ut labore  aliquyamLorem ipsum dolor sit amet, consetetur sadipscing elitr, sed diam ",
  },
  {
    id: 5,
    userImage: <img className="QL---Img---Testimonial" src={img5} alt="img" />,
    userName: "Ali",
    message:
      "Lorem ipsum dolor sit amet, consetetur sadipscing elitr, sed diam nonumy eirmod tempor invidunt ut labore  aliquyamLorem ipsum dolor sit amet, consetetur sadipscing elitr, sed diam ",
  },
  {
    id: 6,
    userImage: <img className="QL---Img---Testimonial" src={img6} alt="img" />,
    userName: "Irum",
    message:
      " Lorem ipsum dolor sit amet, consetetur sadipscing elitr, sed diam nonumy eirmod tempor invidunt ut labore  aliquyamLorem ipsum dolor sit amet, consetetur sadipscing elitr, sed diam ",
  },
  {
    id: 7,
    userImage: <img className="QL---Img---Testimonial" src={img4} alt="img" />,
    userName: "Rida",
    message:
      "Lorem ipsum dolor sit amet, consetetur sadipscing elitr, sed diam nonumy eirmod tempor invidunt ut labore  aliquyamLorem ipsum dolor sit amet, consetetur sadipscing elitr, sed diam ",
  },
];
SwiperCore.use([Navigation]);

export default () => {
 
  
  return (
    <React.Fragment>
      
      <Swiper
        breakpoints={{
          // when window width is >= 640px
          425: {
            width: 390,
            slidesPerView: 1,
          },
          375: {
            width: 375,
            slidesPerView: 1,
          },
          320: {
            width: 290,
            slidesPerView: 1,
          },
          640: {
            width: 640,
            slidesPerView: 1,
          },
          // when window width is >= 768px
          768: {
            width: 720,
            slidesPerView: 2,
          },
          1024: {
            width: 990,
            slidesPerView: 3,
          },
          
          1150: {
            width: 1150,
            slidesPerView: 3,
          },
          
        }}
        id="main"
        width="480"
        navigation
        spaceBetween={5}
        slidesPerView={1}
      >
        {data.map((user) => (
    <SwiperSlide key={user.id} className="slide">
      <div className="slide-content">
        <div className="user-image">{user.userImage}</div>
        <div className="user-name"> {user.userName}</div>
        <div className="user-message">{user.message}</div>
      </div>
    </SwiperSlide>
  ))}
      </Swiper>
    </React.Fragment>
  );
};